import { makeStyles } from '@mui/styles';


const useStyles = makeStyles({ container: { width: "100%" } });

export { useStyles };
